// extracted by mini-css-extract-plugin
module.exports = {"error":"src-components-flowable-Common-ErrorComponent-styles___error"};